import React from 'react';
import PropTypes from 'prop-types';
import { MostPopularCard } from 'site-modules/used-cars-landing/components/most-popular-card/most-popular-card';

export function MostPopularModule({ popularSubmodels, className = null, title }) {
  return (
    <div className={className}>
      <div className="most-popular-module row">
        <h2 className="heading-3 pb-0_5 col-12">{title}</h2>
        {popularSubmodels.map(popularSubmodel => (
          <MostPopularCard
            key={popularSubmodel.id}
            popularSubmodel={popularSubmodel}
            className="col-6 col-md-4 col-lg-3"
            isLazyImage
          />
        ))}
      </div>
    </div>
  );
}

MostPopularModule.propTypes = {
  popularSubmodels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
};
